module.exports = __webpack_public_path__ + "img/star.a9055a7a.svg";